// Token is attached to the `ectechaccounts` Mapbox account,
// whose credentials are in the shared 1Password Vault.
// It is limited in scope to only the CPF web domains:
// https://account.mapbox.com/access-tokens/cl894asp503c63wla2j2xezlb
const mapboxAccessToken =
  "pk.eyJ1IjoiZWN0ZWNoYWNjb3VudHMiLCJhIjoiY2w4OTRhc3A1MDNjNjN3bGEyajJ4ZXpsYiJ9.7rkM1AH7XkDsm4x5_jaWgA";

export { mapboxAccessToken };
